module.exports = __webpack_public_path__ + "static/media/globe.42421249.gif";